import { padDigit } from './helpers';

export default function formatDate(yearOfBirth, monthOfBirth, dayOfBirth) {
  if (yearOfBirth && monthOfBirth && dayOfBirth) {
    return `${yearOfBirth}-${padDigit(monthOfBirth)}-${padDigit(dayOfBirth)}`;
  }
  return '';
}

export function formatDateFriendly(date) {
  if (date instanceof Date) {
    const localeOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    };
    return date.toLocaleString('en-US', localeOptions);
  }
  return '';
}
